import * as React from 'react';
import { ReactElement, useState } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import { Breadcrumbs, Message } from 'slovlex-idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import useAktualitaDetail from './hook/useAktualitaDetail';
import AktualitaDetail from '../../module/Aktuality/Detail/AktualitaDetail';

const AktualitaDetailPage = (): ReactElement => {
  const { id } = useParams();
  const [displayError, setDisplayError] = useState(true);

  const {
    data,
    status,
  } = useAktualitaDetail(id);

  return (
    <Layout>
      <Breadcrumbs
        routeList={[
          {
            to: routes.home.to,
            heading: routes.home.name,
          },
          {
            to: routes.aktuality.to,
            heading: routes.aktuality.name,
          },
          {
            to: routes.aktuality.detail.withParams(id || ''),
            heading: data && data.title,
          }]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399)
          ? (
            <>
              {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať detail aktuality.
              </Message>
              )}
            </>
          )
          : (
            id && (
              <AktualitaDetail
                aktualita={data}
              />
            )
          )}
      </Loader>
    </Layout>
  );
};

export default AktualitaDetailPage;
